module.exports = __webpack_public_path__ + "static/media/checkmark.f02e8a49.svg";